import { Page, View, Text, Image } from '@react-pdf/renderer';
import { styles } from './styles';
import {
  PublicAttendee,
  PublicEventDetailsResponse,
} from '@hubs101/booking-api-skd-client/lib/types';
import { globalStyles } from '../../styles';
import { useTranslation } from 'react-i18next';
import { getImageSrc } from '@utils/fn';

export interface ListOfAttendeesPageProps {
  event: PublicEventDetailsResponse;
  footer: JSX.Element;
  attendees: PublicAttendee[] | undefined;
}

const ListOfAttendeesPage = ({
  event,
  footer,
  attendees,
}: ListOfAttendeesPageProps) => {
  const { t } = useTranslation();

  const attendeesList = attendees?.filter(
    (attendee: PublicAttendee) => attendee?.company?.logo
  );

  return (
    <Page size={{ width: 1440, height: 800 }} style={styles.page}>
      <View style={styles.fullWidthContainer}>
        <Text style={styles.pageTitle}>{t('list-of-attendees')}</Text>
        <View
          style={{
            ...globalStyles.lineBar,
            alignSelf: 'flex-start',
            borderColor: event?.design?.themeColor ?? 'black',
            marginLeft: 0,
            marginBottom: 20,
          }}
        />

        <View style={styles.galleryContainer}>
          {(attendeesList || []).map((item, index) => {
            const logoSrc = getImageSrc(item?.company?.logo);
            return (
              logoSrc && (
                <Image key={index} style={styles.logoImage} src={logoSrc} />
              )
            );
          })}
        </View>
      </View>

      {footer}
    </Page>
  );
};

export default ListOfAttendeesPage;
